/**
 * Global Fields Provider
 * Provides a singleton FieldRepository instance that loads fields from both static and API sources
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ref } from "vue";
import { FieldRepository } from "@/core/fields/field-repository";
import { fetchObjectiveFields } from "@/views/objectives-report/api/fields";
import { FIELDS } from "@/views/results-report/api/fields";
// Create singleton instance immediately with static fields
const fields = new FieldRepository();
fields.register(FIELDS);
const instance = {
    isLoading: ref(true),
    isReady: ref(false),
    error: ref(null),
    fields,
};
/**
 * Get the global FieldRepository instance
 * Can be called immediately - returns instance with static fields
 */
export function getFieldsRepository() {
    return instance.fields;
}
/**
 * Initialize the global fields provider
 * Loads dynamic fields from API and registers them
 * Falls back to static-only if API fails
 */
export function initializeFieldsProvider() {
    return __awaiter(this, void 0, void 0, function* () {
        if (instance.isReady.value) {
            return;
        }
        try {
            // Attempt to load API fields
            const apiFields = yield fetchObjectiveFields();
            // await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate delay
            instance.fields.register(apiFields);
        }
        catch (err) {
            // Fail silently - we already have static fields
            instance.error.value = "Failed to load dynamic fields from API. Using static fields only.";
            console.warn("Failed to load API fields:", err);
        }
        finally {
            instance.isLoading.value = false;
            instance.isReady.value = true;
        }
    });
}
/**
 * Get the current provider state
 */
export function getFieldsProviderState() {
    return instance;
}
